import SessionTableEvent from './SessionTableEvent';

export default SessionTableEvent;
